export default __webpack_public_path__ + "static/O0247-516f2bfe418bc3bc20e23d8e8b6fdf4c.png";